import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {performSignedFileQuery} from 'external-files/ExternalFileUtils';
import Chip, {ChipSize} from 'ui-library/chips/Chip';

import {ScratchFileContent} from './ScratchFileTypes';

interface ScratchFileChipProps {
  scratchFile: ScratchFileContent;
}

export default function ScratchFileChip({scratchFile}: ScratchFileChipProps): JSX.Element {
  async function handleClick(): Promise<void> {
    const signedURL = await performSignedFileQuery(
      scratchFile.externalFileId!,
      scratchFile.downloadUrl!,
      scratchFile.id
    );
    if (signedURL == null) {
      return;
    }
    window.open(signedURL, '_blank', 'noopener noreferrer');
  }

  return (
    <Chip
      className="chip-container"
      icon={ModelTypeConstants.EXTERNAL_FILE}
      onClick={handleClick}
      size={ChipSize.SMALL}
      text={scratchFile.filename}
    />
  );
}
